export { getStyle } from './getStyle';
